import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import styled from "styled-components";
import React from "react";
import { Breadcrumbs } from "Components/Breadcrumbs/Breadcrumbs";
import { ARTICLEPAGE, VIDEOPAGE } from "Consts/pageTypes";

export const Page = ({ Alias, children, Breadcrumb }) => {
	return (
		<PageContainer>
			{(Alias == ARTICLEPAGE || Alias == VIDEOPAGE) && (
				<Breadcrumbs {...Breadcrumb}></Breadcrumbs>
			)}
			{children}
		</PageContainer>
	);
};
export const PageContainer = styled.div`
	background-color: ${({ bgColor, theme }) => (bgColor ? bgColor : theme.colors.white)};
	padding: 50px 65px 50px 122px;
	flex-basis: 80%;
	padding-top: ${({ paddingtop }) => (paddingtop ? paddingtop : "")};
	min-height: 500px;

	${media.lessThan(breakpoints.ipad)`
	padding-top: ${({ paddingtop }) => (paddingtop ? paddingtop : "")};
	padding: 50px 40px;

  
  `}
	${media.lessThan(breakpoints.mobile)`
  padding: 10px;
	padding-top: ${({ paddingtop }) => (paddingtop ? paddingtop : "")};

  `}
`;
